
export const sleep = (duration: number) => new Promise(resolve => setTimeout(resolve, duration))

export function delayedToggle(data: boolean, duration = 1000) {
  return new Promise<{ data: boolean }>((resolve) =>
    setTimeout(() => resolve({ data: data }), duration)
  )
}